// extracted by mini-css-extract-plugin
module.exports = {"content":"WidgetNetSalesByProvider_content__j_h3x"};